import React, { useRef, useEffect } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { Layout } from '@components';
import { Carousel } from 'react-responsive-carousel'; // Import your carousel library here
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Ensure styles are imported
import Image2 from '@images/gdg/2022.png';
import Image4 from '@images/gdg/2023.png';
import Image5 from '@images/gdg/2024.png';

import { usePrefersReducedMotion } from '@hooks';

const StyledPageContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px; /* Set maximum width for the entire page */

  .project-tech-list {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
    margin: 25px 0 10px;
    padding: 0;
    list-style: none;

    li {
      margin: 0 20px 5px 0;
      color: var(--light-slate);
      font-family: var(--font-mono);
      font-size: var(--fz-xs);
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      margin: 10px 0;

      li {
        margin: 0 10px 5px 0;
        color: var(--lightest-slate);
      }
    }
  }

  img {
    border-radius: var(--border-radius);
  }
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(280px, 400px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    @media (max-width: 768px) {
      grid-template-columns: repeat(1, minmax(280px, 400px));
    }

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-sans);
      font-size: var(--fz-xl);
      @media (max-width: 768px) {
        font-size: var(--fz-lg);
      }

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 24px;

        @media (max-width: 768px) {
          line-height: 20px;
        }
      }
    }
  }
`;

const StyledCarouselContainer = styled.div`
  margin: 50px auto; /* Adjust margin as needed */
`;

const PrigraPage = ({ location, data }) => {
  const revealTitle = useRef(null);
  const revealCarousel = useRef(null);
  const revealPara = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealTitle.current, srConfig());
    sr.reveal(revealPara.current, srConfig(200, 0));
    sr.reveal(revealCarousel.current, srConfig(400, 0));
  }, []);

  const tech = ['React.Js', 'Tailwind.CSS', 'TypeScript', 'Vite', 'Figma'];

  const skills = [
    'Account and role management',
    'Project submission and validation',
    'Project progress tracking',
    'Project defense management',
    'Announcements management',
    'Repository management',
    'Statistics management',
    'Notifications management',
  ];

  return (
    <Layout location={location}>
      <Helmet title="Gdg" />

      <StyledPageContainer>
        <main>
          <header>
            <h1 className="big-heading" ref={revealTitle}>
              Détails du projet
            </h1>
            <div ref={revealPara}>
              <p className="subtitle">Le club GDG SBA</p>
              <p>
                GDG SBA, pour Google Developer Group Sidi Bel Abbès, est une communauté locale de
                passionnés de tech en Algérie, affiliée aux Google Developer Groups. Son objectif
                est de connecter, d’innover et de faire grandir les talents algériens de la tech,
                à travers des événements comme le DevFest ou les célébrations de la Journée
                internationale des droits des femmes (IWD), mais aussi des projets et de la
                collaboration entre passionnés.
              </p>
              <p className="subtitle">Le site GDG SBA</p>
              <p>
                Le site GDG SBA a été conçu pour présenter le club : ses objectifs et ses principaux
                événements, afin de donner envie de le rejoindre et de collaborer. Il présente le
                club, détaille sa mission et ses objectifs, et met en avant les événements passés
                comme à venir, pour que les futurs membres comprennent ce qu’ils peuvent y trouver.
              </p>

              <p>
                Découvrez le site du club GDG SBA en ligne.{' '}
                <a href="https://www.gdg-sba.club/" target="_blank" rel="noreferrer">
                  Site GDG SBA
                </a>
              </p>
            </div>
          </header>

          <StyledCarouselContainer ref={revealCarousel}>
            <Carousel
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              autoPlay
              interval={3000}
              infiniteLoop>
              <div>
                <img src={Image2} alt="Image 1" />
              </div>
              <div>
                <img src={Image4} alt="Image 2" />
              </div>
              <div>
                <img src={Image5} alt="Image 3" />
              </div>
            </Carousel>
          </StyledCarouselContainer>
          <p className="subtitle">Technologies utilisées</p>
          {tech.length && (
            <ul className="project-tech-list">
              {tech.map((tech, i) => (
                <li key={i}>{tech}</li>
              ))}
            </ul>
          )}
        </main>
      </StyledPageContainer>
    </Layout>
  );
};

PrigraPage.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default PrigraPage;
